import css from './WhiteSection.module.scss';
import classNames from 'classnames';

export default function WhiteSection({children, cn}) {
  return (
    <section className={classNames(css.section, cn)}>
      {children}
    </section>
  );
}